import "./X.css"
import React from "react"

const X = (props)=> <div className="X" onClick={props.onClick}>
  <svg viewBox="0 0 20 20">
    <path className="Profile__close__x" d="M 5,5 L 15,15 M 15,5 L 5,15" />
  </svg>
</div>

export default X


// WEBPACK FOOTER //
// ./src/components/X.js